interface WrapProps extends React.PropsWithChildren {
  if: boolean;
  with: (children: React.ReactNode) => JSX.Element;
  else?: (children: React.ReactNode) => JSX.Element;
}

const Wrap: React.FC<WrapProps> = ({
  if: condition,
  with: wrapper,
  else: fallback,
  children,
}) => {
  if (condition) {
    return wrapper(children);
  } else {
    if (fallback) {
      return fallback(children);
    } else {
      return <>{children}</>;
    }
  }
};

export { Wrap };
